<template>
    <div class="main-product__tech-spec-conatiner" :style="{ backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), url(${specimage})` }">
        <div class="container main-product__tech-specs">
        <h2 class="text-heading-3xl text-heading-5xl-desktop">
          {{specstext}}
        </h2>     
        <div class="grid main-product__tech-grid">

            <template v-for="(spec, index) of techSpecs"
            :key="index"
            
            >
            <product-stat
            class="col xs-span m6 l6"
            v-if="product[spec.value] || liquid[spec.value]"
            :key="index"
            :label="spec.label"
            label-class="text-body-xl-regular"
            :value="product[spec.value] || liquid[spec.value]"
            :unit="spec.unit"
            :desc="product[spec.desc] || liquid[spec.desc]"
            />
        </template>
            </div>
        </div>
    </div>
  </template>
  
  <script>
import MainProductSidebarUsp from './main-product-sidebar-usp'
import TransitionHeight from '~async/transition-height/transition-height'
import Btn from '~global/btn/btn'
import IconMinus from '~icons/directional-navigation/minus.svg'
import IconPlus from '~icons/directional-navigation/plus.svg'
import ProductStat from '~global/product-stat/product-stat'

export default {
  name: 'TechSpecs',
  components: {
    TransitionHeight,
    Btn,
    MainProductSidebarUsp,
    IconMinus,
    IconPlus,
    ProductStat,
  },
  props: {
    liquid: {
      type: Object,
      default: () => ({
        description: '',
        price: 0,
        title: '',
      }),
    },
    specimage :{
      type: String ,
      default:''
    },
    specstext:{
      type: String ,
      default:'Specs'
    },
    product: {
      type: [Boolean, Object],
      default: false,
    },
    variant: {
      type: [Boolean, Object],
      default: false,
    },
  },

  data() {
    return {
      techSpecsData: [
        {
          label: this.$string('compare.log_diameter'),
          value: 'logDiameter',
          unit: this.$string('compare.log_diameter_unit'),
          desc: 'logDiameterTooltip',
        },
        {
          label: this.$string('compare.width_of_cut'),
          value: 'widthOfCut',
          unit: this.$string('compare.width_of_cut_unit'),
          desc: 'boardWidthTooltip',
        },
        {
          label: this.$string('compare.depth_of_cut'),
          value: 'depthOfCut',
          unit: this.$string('compare.depth_of_cut_unit'),
          desc: 'depthOfCutTooltip',
        },
        {
          label: this.$string('compare.max_horsepower'),
          value: 'maxHorsepower',
          unit: this.$string('compare.max_horsepower_unit'),
          desc: 'maxHorsepowerTooltip',
        },
      ],
  
    }
  },

  computed: {
    /**
     * Compute tech specs.
     */
    techSpecs() {
      const techSpecs = []

      this.techSpecsData.forEach((spec) => {
        if (this.product[spec.value] || this.liquid[spec.value]) {
          techSpecs.push(spec)
        }
      })

      return techSpecs
    },

    /**
     * Compute additional accordion.
     * - Parses a single richtext string into an array of objects that will
     * be used to render multiple separate accordions.
     */

  },

  mounted() {
    // not empty
  },

  methods: {
  },
}
</script>